var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-down"}},[(!_vm.isOnline)?_c('div',{staticClass:"offline-indicator"},[_c('i',{staticClass:"lni lni-signal mr-2"}),_vm._v(" You are offline. Khatm and Counter features require internet connection. "),_c('br'),_c('small',[_vm._v("Tasbih counter will continue to work offline.")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }